<template>
  <section
    class="pedido-kanban-lane"
    :class="{ 'is-mobile-active': active }"
    :aria-labelledby="`pedido-lane-${definition.key}`"
  >
    <header class="pedido-lane-header">
      <div>
        <h2 :id="`pedido-lane-${definition.key}`">
          {{ definition.label }}
          <span :aria-label="`${lane.total} pedidos`">{{ lane.total }}</span>
        </h2>
        <p>{{ definition.description }}</p>
      </div>
    </header>

    <div class="pedido-lane-scroll" :aria-busy="loading ? 'true' : 'false'">
      <div
        v-if="loading && !lane.items.length"
        class="lane-state"
        role="status"
      >
        <span
          class="spinner-border spinner-border-sm"
          aria-hidden="true"
        ></span>
        Carregando pedidos...
      </div>

      <div v-else-if="!lane.items.length" class="lane-state lane-empty">
        <i class="far fa-check-circle" aria-hidden="true"></i>
        <strong>Nenhum pedido nesta etapa</strong>
        <span>Quando houver movimentação, ela aparecerá aqui.</span>
      </div>

      <pedido-kanban-card
        v-for="order in lane.items"
        v-else
        :key="cardKey(order)"
        :order="order"
        :server-time="serverTime"
        :now="now"
        :active="String(selectedId) === String(cardKey(order))"
        @select="(value, element) => $emit('select', value, element)"
      />

      <button
        v-if="lane.next_cursor"
        type="button"
        class="btn btn-light-primary font-weight-bolder lane-load-more"
        :disabled="loadingMore"
        @click="$emit('load-more', definition.key)"
      >
        <span
          v-if="loadingMore"
          class="spinner-border spinner-border-sm mr-2"
          aria-hidden="true"
        ></span>
        {{ loadingMore ? "Carregando..." : "Carregar mais" }}
      </button>
    </div>
  </section>
</template>

<script>
import PedidoKanbanCard from "./PedidoKanbanCard.vue";
import { orderId } from "./orderBoard";

export default {
  name: "PedidoKanbanLane",
  components: { PedidoKanbanCard },
  props: {
    definition: { type: Object, required: true },
    lane: { type: Object, required: true },
    serverTime: { type: String, default: null },
    now: { type: Number, default: () => Date.now() },
    active: { type: Boolean, default: false },
    selectedId: { type: [String, Number], default: null },
    loading: { type: Boolean, default: false },
    loadingMore: { type: Boolean, default: false },
  },
  methods: {
    cardKey: orderId,
  },
};
</script>

<style scoped>
.pedido-kanban-lane {
  background: #f5f7fa;
  border: 1px solid #e4e6ef;
  border-radius: 12px;
  display: flex;
  flex: 1 0 270px;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  min-width: 270px;
  overflow: hidden;
}

.pedido-lane-header {
  background: #fff;
  border-bottom: 1px solid #e4e6ef;
  padding: 15px 16px 13px;
  position: sticky;
  top: 0;
  z-index: 2;
}

.pedido-lane-header h2 {
  align-items: center;
  color: #181c32;
  display: flex;
  font-size: 15px;
  font-weight: 800;
  gap: 8px;
  margin: 0;
}

.pedido-lane-header h2 span {
  align-items: center;
  background: #e9edf3;
  border-radius: 999px;
  color: #5e6278;
  display: inline-flex;
  font-size: 11px;
  justify-content: center;
  min-height: 23px;
  min-width: 23px;
  padding: 0 7px;
}

.pedido-lane-header p {
  color: #7e8299;
  font-size: 11px;
  font-weight: 600;
  margin: 4px 0 0;
}

.pedido-lane-scroll {
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 10px;
  min-height: 0;
  overflow-y: auto;
  overscroll-behavior: contain;
  padding: 10px;
  scrollbar-gutter: stable;
}

.lane-state {
  align-items: center;
  color: #7e8299;
  display: flex;
  font-size: 12px;
  font-weight: 700;
  gap: 8px;
  justify-content: center;
  min-height: 110px;
  text-align: center;
}

.lane-empty {
  flex-direction: column;
  padding: 20px 12px;
}

.lane-empty i {
  color: #b5b5c3;
  font-size: 24px;
}

.lane-empty strong {
  color: #5e6278;
}

.lane-empty span {
  font-size: 11px;
  font-weight: 500;
  max-width: 190px;
}

.lane-load-more {
  flex: 0 0 auto;
  min-height: 44px;
  width: 100%;
}

@media (min-width: 1200px) {
  .pedido-kanban-lane {
    flex: 1 1 270px;
  }
}

@media (max-width: 1199px) {
  .pedido-kanban-lane {
    display: none;
    flex: 1 1 auto;
    min-width: 100%;
    width: 100%;
  }

  .pedido-kanban-lane.is-mobile-active {
    display: flex;
  }

  .pedido-lane-scroll {
    min-height: 0;
    overflow-y: auto;
  }
}
</style>
